import colorPalette from '../color-palette';

const { background, primary } = colorPalette;

export default {
  MuiInputBase: {
    root: {
      height: '48px',
      backgroundColor: background.textInput,
      paddingLeft: '11px',
      fontSize: '16px',
    },
    input: {
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
        {
          '-webkit-text-fill-color': primary.main,
          '-webkit-box-shadow': `0 0 0px 1000px ${background.textInput} inset`,
          transition: 'background-color 5000s ease-in-out 0s',
        },
    },
  },
};
